// User Timing marks for the All documents load, to check the client-group hold window on a real
// tenant: DevTools > Performance > Timings shows each phase measured from the start of the load.
// Nothing is logged or sent, and a browser without the API records nothing.

const PREFIX = "Docubird All documents";
const START_MARK = `${PREFIX}: start`;

/** "own rows": the site's own rows are ready; "painted": rows are on screen; "group joined": the
 * client group's rows are merged in. */
export type AggregatedLoadPhase = "own rows" | "painted" | "group joined";

const PHASES: AggregatedLoadPhase[] = ["own rows", "painted", "group joined"];

/** Starts a load. The previous load's entries go, so each phase shows once per load. */
export const markAggregatedLoadStart = (): void => {
    try {
        PHASES.forEach(phase => performance.clearMeasures(`${PREFIX}: ${phase}`));
        performance.clearMarks(START_MARK);
        performance.mark(START_MARK);
    } catch {
        // No User Timing API: nothing to record.
    }
};

export const measureAggregatedLoad = (phase: AggregatedLoadPhase): void => {
    try {
        performance.measure(`${PREFIX}: ${phase}`, START_MARK);
    } catch {
        // No User Timing API, or no load started: nothing to record.
    }
};
